export default "__VITE_ASSET__BBUdT_NY__"